import { createAction } from '@reduxjs/toolkit';

import { ResetPassword } from 'redux/types';
import { withPayloadType } from 'utils';

export const resetPasswordStart = createAction(
  'RESET_PASSWORD::START',
  withPayloadType<ResetPassword>(),
);
